var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"870cca7432063c1f4bb93f437a8de0216f6f0f49"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["virra-app@virra"]={id:"870cca7432063c1f4bb93f437a8de0216f6f0f49"};
      